'use strict';

var util = angular.module('gymsystem.util');

util.directive('entrylist', ['$rootScope', '$modal', '$location', '$filter', function($rootScope, $modal, $location, $filter) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {
            var fromDate = new Date().clearTime();
            if ($scope.settings.daysBack) {
                fromDate.addDays(-$scope.settings.daysBack);
            }

            var getRowClass = function(entry) {
                return entry.success ? 'success' : 'danger';
            };

            var gotoCustomer = function(entry) {
                $rootScope.gotoCustomer(entry.Member);
            };

            var addWorkoutBooking = function(entry) {
                $modal.open({
                    templateUrl: 'views/addbookingmodal.html',
                    controller: 'BookingAddModalCtrl',
                    resolve: {
                        customer: function() {
                            return entry.Member;
                        }
                    }
                });
            };
            var addPayment = function(entry) {
                $modal.open({
                    templateUrl: 'views/addmodal.html',
                    controller: 'PaymentAddModalCtrl',
                    resolve: {
                        customer: function() {
                            return entry.Member;
                        }
                    }
                });
            };

            var addTrainingCard = function(entry) {
                $rootScope.showCombo({ customer: entry.Member });
            };

            var gotoJournal = function(entry) {
                $location.path('/customer/journal/' + entry.Member.id);
            };
            $scope.config = {
                api: {
                    url: '/api/entry/get',
                    args: {
                        fromDate: fromDate.yyyymmdd(),
                        idOnly: true, 
                        door: $scope.settings.resource
                    },
                    debounce: 300,
                    triggers: [{type: 'entry'}],
                    transform: $rootScope.transformEntry
                },
                hideSearch: true,
                tableLimit: 10,
                tableOverflow: 'unset',
                rowClass: getRowClass,
                rowClick: gotoCustomer,
                orderColumn: '-entryTime',
                columns: [
                    { field: 'image', src: function(entry) { return $rootScope.smallMemberImage(entry.Member); } },
                    { field: 'Member.name', title: 'Name' },
                    { field: 'cardName', title: 'Trainingcard', getValue: function(entry) { return (!entry.success && entry.reason) ? $filter('translate')(entry.reason) : entry.cardName; } },
                    { field: 'entryTime', title: 'Time', format: 'time', compare: function(a, b) { return a.entryTime - b.entryTime; } },
                    { field: 'door.name', title: 'Door' },
                ],
                multibutton: {
                    title: 'Shortcuts',
                    inline: true,
                    alignRight: true,
                    buttonClass: function() { return 'btn-primary'; },
                    actions: [
                        { title: 'Show customer', onClick: gotoCustomer },
                        { title: 'Add booking', onClick: addWorkoutBooking, visible: function() { return $rootScope.hasModule('WorkoutBooking'); } },
                        { title: 'Add payment', onClick: addPayment, visible: function() { return $rootScope.hasPermission('Training card handling'); } },
                        { title: 'Add training card', onClick: addTrainingCard, visible: function() { return $rootScope.hasPermission('Customer handling'); } },
                        { title: 'Go to customer journal', onClick: gotoJournal, visible: function() { return $rootScope.hasPermission('Show customer journal'); } },
                    ]
                }
            };
        }
    };
}]);
